
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';function Punetokonkandarshan() {



    const cardData =
    {
        keyword: ' Pune to Konkan Darshan Cab',
        heading: 'Prince Cabs: Pune to Konkan Darshan Cab',
        headingDescription: 'Prince Cabs offers comfortable and affordable Pune to Konkan Darshan Cab services, perfect for family tours, group outings, beach holidays, and temple visits. Our fleet of well-maintained sedans, SUVs, and luxury cars ensures a smooth and safe journey through the scenic Konkan coastal routes. With professional chauffeurs, flexible travel itineraries, and on-time pickups, we make your Konkan Darshan trip hassle-free and enjoyable. Experience the beauty of beaches, temples, and greenery with Prince Cabs’ trusted Pune to Konkan Darshan taxi service, designed for convenience, comfort, and reliability..',

        top: 'Top Places to Visit in Konkan with Prince Cabs',

"topPlaces": [
  {
    "title": "Ganpatipule Beach & Temple",
    "description": "Ganpatipule is one of the most famous destinations in Konkan, known for its pristine beach and the 400-year-old Swayambhu Ganapati Temple. The temple houses a naturally formed idol of Lord Ganesha believed to be self-manifested. The golden sands and turquoise waters of the beach create a serene environment. Tourists enjoy water sports, camel rides, and evening strolls along the coast. The site is spiritually uplifting and visually stunning. It is a perfect blend of devotion and relaxation."
  },
  {
    "title": "Sindhudurg Fort",
    "description": "Built by Chhatrapati Shivaji Maharaj in the 17th century, Sindhudurg Fort stands proudly on an island off Malvan. The massive stone walls, bastions, and hidden passages reflect Maratha naval strength. The fort also houses a temple dedicated to Shivaji Maharaj, the only one of its kind. Surrounded by the Arabian Sea, it offers breathtaking views and a glimpse into Maratha history. Adventure seekers enjoy ferry rides to the fort and exploring its ruins. It remains one of Konkan’s most iconic heritage sites."
  },
  {
    "title": "Alibaug",
    "description": "Alibaug, located in Raigad district, is a popular coastal town often called the ‘Goa of Maharashtra.’ Known for its clean beaches like Varsoli and Nagaon, it is perfect for weekend getaways from Mumbai and Pune. Alibaug Fort and Kolaba Fort add historical charm to the town. The region is also famous for water sports, beach resorts, and seafood delicacies. Sunsets at Alibaug are especially mesmerizing. Its easy accessibility makes it a favorite holiday destination in Konkan."
  },
  {
    "title": "Tarkarli Beach",
    "description": "Tarkarli, in Sindhudurg, is famous for its white sandy beaches and crystal-clear waters. It is Maharashtra’s top destination for scuba diving and snorkeling, thanks to its vibrant coral reefs and marine life. Tourists also enjoy parasailing, boating, and dolphin-spotting rides. The calm and scenic beach is less crowded, offering peace and natural beauty. Homestays near the beach provide authentic Konkani hospitality. Tarkarli is a paradise for adventure lovers and sea enthusiasts."
  },
  {
    "title": "Murud-Janjira Fort",
    "description": "Murud-Janjira Fort, located near Alibaug, is a mighty sea fort built on an island in the Arabian Sea. Known as the ‘invincible fort,’ it was never conquered in its history. The fort’s 19 bastions, freshwater lakes, and secret escape routes fascinate visitors. Accessible only by boats, the fort offers a thrilling experience. It is a testament to the architectural brilliance of the Siddis who built it. The fort is a must-visit for history buffs and adventure seekers alike."
  },
  {
    "title": "Dapoli",
    "description": "Dapoli, often called ‘Mini Mahabaleshwar of Konkan,’ is a coastal hill station known for its pleasant climate and pristine beaches. Popular beaches like Karde and Murud attract visitors for dolphin-watching tours and relaxation. The region is also home to historic temples and ancient caves. Coconut groves, lush greenery, and quiet surroundings make it ideal for a peaceful vacation. The local seafood adds to its charm. Dapoli is a hidden gem combining nature, history, and leisure."
  },
  {
    "title": "Velas Beach (Turtle Festival)",
    "description": "Velas, a small village in Ratnagiri district, is famous for its annual Turtle Festival. The event is organized to protect Olive Ridley turtles, where visitors can witness baby turtles being released into the sea. The beach itself is quiet, clean, and scenic, offering a raw natural charm. Eco-tourism initiatives by locals make it a unique destination. The festival attracts wildlife enthusiasts and families alike. Velas highlights Konkan’s blend of conservation, culture, and beauty."
  },
  {
    "title": "Hedvi Ganesh Temple & Beach",
    "description": "Hedvi is a small coastal village known for its Dashabhuja Ganesh Temple (idol with ten arms) and its picturesque black sand beach. The temple holds religious importance and is surrounded by calm natural settings. Nearby, the ‘Brahman Ghal’ rock gorge is a geological wonder with a stream flowing through it. The beach offers solitude and stunning views of the Arabian Sea. Hedvi is ideal for spiritual seekers and nature lovers. It is a peaceful retreat away from crowded tourist spots."
  },
  {
    "title": "Harihareshwar",
    "description": "Harihareshwar, known as ‘Dakshin Kashi,’ is a famous pilgrimage town in Raigad district. It is home to an ancient Shiva temple surrounded by four hills. The town also has a beautiful beach, offering scenic walks and breathtaking sunsets. Pilgrims perform rituals at the temple, while tourists enjoy the natural surroundings. The combination of religion and coastal beauty makes it a popular destination. Harihareshwar is a serene stop for both spiritual and leisure travelers."
  },
  {
    "title": "Ratnagiri Beaches & Thibaw Palace",
    "description": "Ratnagiri district offers a mix of pristine beaches like Ganeshghule, Aare-Ware, and Mandvi, along with historic sites. The Thibaw Palace, built for the exiled king of Burma, adds cultural charm to the town. Ratnagiri is also famous for its Alphonso mangoes, which attract visitors during the summer season. The blend of heritage, natural beauty, and local cuisine makes it a highlight of Konkan. Visitors love its calm beaches, forts, and traditional Konkani culture. It’s a must-explore destination for travelers."
  }
],


"services": [
    {
        "name": "Pune to Diveagar Cab",
        "description": "Book a comfortable cab from Pune to Diveagar, a serene beach destination in the Konkan region. Our service includes air-conditioned vehicles, professional drivers, and flexible pickup options. Enjoy a scenic coastal drive with safe and reliable transportation perfect for weekend getaways, family trips, or romantic escapes."
    },
    {
        "name": "Pune to Palghar Cab Booking",
        "description": "Plan a smooth and stress-free journey from Pune to Palghar with our cab booking service. We offer clean and well-maintained vehicles, trained drivers, and affordable packages for both one-way and round-trip travel. Ideal for business travelers, students, and tourists visiting the northern Konkan area."
    },
    {
        "name": "Pune to Raigad Taxi Price",
        "description": "Check our affordable and transparent taxi pricing for trips from Pune to Raigad Fort or Raigad district. Our services are ideal for heritage tourism, trekking groups, or historical tours. Enjoy well-maintained vehicles, courteous drivers, and flexible booking options at the best price."
    },
    {
        "name": "Pune to Ratnagiri Innova Crysta Taxi Fare",
        "description": "Travel in comfort and style from Pune to Ratnagiri with our Innova Crysta taxi service. Spacious, air-conditioned, and feature-rich, this vehicle is ideal for long-distance coastal drives with family or friends. Get competitive fare packages, experienced chauffeurs, and flexible return options."
    },
    {
        "name": "Pune to Sindhudurg by Cab",
        "description": "Explore the beautiful coastal region of Sindhudurg with our Pune to Sindhudurg cab service. We provide well-maintained vehicles, experienced drivers familiar with the Konkan routes, and options for sightseeing stops en route. Perfect for cultural tours, beach visits, or local food exploration."
    },
    {
        "name": "Pune to Thane Cab",
        "description": "Book a reliable cab from Pune to Thane for business travel, family visits, or airport transfers. Our fleet includes sedans, SUVs, and premium cars with courteous drivers and on-time pickups. Get fixed pricing and comfortable travel for your urban journey."
    },
    {
        "name": "Pune to Kalyan Cab",
        "description": "Hire a cab from Pune to Kalyan for a smooth intercity travel experience. Ideal for daily commuters, office-goers, or families visiting relatives, our service offers well-maintained cars, flexible timings, and professional drivers who ensure a timely and safe ride."
    },
    {
        "name": "Pune to Dapoli Taxi Service",
        "description": "Head to the scenic beach town of Dapoli with our reliable taxi service from Pune. Enjoy a peaceful ride through the Western Ghats and coastal highways in a comfortable vehicle. Our service is perfect for family vacations, weekend trips, and beach holidays with door-to-door convenience."
    },
    {
        "name": "Pune to Shrivardhan Cab",
        "description": "Plan a coastal escape from Pune to Shrivardhan with our cab services. We offer both one-way and round-trip packages for travelers seeking a quiet beach experience. Our experienced drivers ensure a smooth ride, and our vehicles offer ample space and comfort for long drives."
    },
    {
        "name": "Pune to Guhagar Innova Cab",
        "description": "Travel to Guhagar in a spacious and premium Innova cab from Pune. Ideal for group travel or family holidays, the vehicle offers luxury interiors, air conditioning, and generous luggage space. Discover clean beaches and traditional Konkan hospitality with stress-free travel."
    },
    {
        "name": "Pune to Konkan Tour Cab",
        "description": "Embark on a scenic Konkan tour from Pune with our specially curated cab packages. Cover popular destinations like Ratnagiri, Ganpatipule, Dapoli, and more with one seamless service. Our tour cabs include experienced drivers, customizable routes, and flexible stopovers."
    },
    {
        "name": "Pune to Konkan Family Taxi",
        "description": "Travel to the Konkan coast with your entire family in our dedicated family taxi service from Pune. Our vehicles are clean, spacious, and equipped for long drives, making your vacation comfortable and safe. Child seating, extra luggage space, and flexible stops are all included."
    }
],
"tableData": [
    ["Pune to Diveagar Cab", "Pune to Palghar Cab Booking"],
    ["Pune to Raigad Taxi Price", "Pune to Ratnagiri Innova Crysta Taxi Fare"],
    ["Pune to Sindhudurg by Cab", "Pune to Thane Cab"],
    ["Pune to Kalyan Cab", "Pune to Dapoli Taxi Service"],
    ["Pune to Shrivardhan Cab", "Pune to Guhagar Innova Cab"],
    ["Pune to Konkan Tour Cab", "Pune to Konkan Family Taxi"]
],


"whychoose": [
    {
        "WhyChooseheading": "Scenic Pune to Konkan Darshan Cab Service",
        "WhyChoosedescription": "Prince Cabs offers a specialized cab service for Konkan Darshan tours starting from Pune, perfect for families, groups, or solo travelers seeking to explore the breathtaking beauty, beaches, temples, forts, and cultural richness of the Konkan coastline. We ensure a relaxed, scenic, and memorable journey across Maharashtra’s most picturesque region."
    },
    {
        "WhyChooseheading": "Comfortable and Tour-Friendly Vehicles for Long Routes",
        "WhyChoosedescription": "Our cabs are spacious, clean, and equipped with air-conditioning, plush seats, and sufficient luggage space to support multi-day Konkan Darshan tours. From Ratnagiri and Ganpatipule to Sindhudurg, Dapoli, or Harihareshwar, our vehicles are ideal for covering long distances comfortably while enjoying every moment of the coastal drive."
    },
    {
        "WhyChooseheading": "Experienced Drivers Familiar with Coastal Routes",
        "WhyChoosedescription": "Our drivers are well-versed with Konkan’s winding ghats, coastal highways, and remote village roads. They ensure a safe and pleasant travel experience while guiding you through local tips, food stops, and hidden gems along the way. Their local knowledge enhances your Darshan tour with insights you won’t get elsewhere."
    },
    {
        "WhyChooseheading": "Flexible Multi-Day Tour Plans Tailored to Your Schedule",
        "WhyChoosedescription": "We understand that Konkan Darshan is not a quick trip, which is why we offer customizable packages—2 days, 3 days, or even a week-long plan, depending on your interest and time. Whether you're visiting religious sites like Ganpatipule and Parshuram Temple or beaches like Tarkarli and Diveagar, we adjust your itinerary for a relaxed experience."
    },
    {
        "WhyChooseheading": "Hygienic and Well-Maintained Fleet for a Safe Journey",
        "WhyChoosedescription": "Every vehicle undergoes thorough cleaning and sanitization before and after the tour. Our fleet is regularly serviced to ensure zero breakdowns during your long road trip. We also provide vehicles equipped with safety essentials like first-aid kits, emergency tools, and GPS tracking for added security during remote travel."
    },
    {
        "WhyChooseheading": "Transparent Tour Pricing with No Hidden Charges",
        "WhyChoosedescription": "Prince Cabs offers fixed and transparent pricing for Konkan Darshan tour packages. You’ll receive a clear cost breakdown that includes fuel, driver allowance, tolls (if any), and night halts. No hidden charges or last-minute surprises—only honest, upfront billing with support for UPI, cards, net banking, and cash payments."
    },
    {
        "WhyChooseheading": "24/7 Travel Support Throughout Your Darshan Tour",
        "WhyChoosedescription": "Our customer support team is available 24x7 to assist you during your entire Konkan trip. Whether you need itinerary help, hotel suggestions, an extra stop, or urgent assistance, we’re just a call or message away—ensuring your Konkan Darshan with Prince Cabs is smooth, safe, and truly unforgettable."
    }
]
















    }

const faqData = [
    {
        question: 'Does Prince Cabs offer Pune to Konkan Darshan cab services?',
        answer: 'Yes, Prince Cabs offers special cab packages from Pune to Konkan for a memorable Konkan Darshan covering scenic beaches, temples, and cultural spots.',
    },
    {
        question: 'What destinations are covered in the Konkan Darshan tour?',
        answer: 'Our Konkan Darshan cab service typically includes popular destinations like Ganpatipule, Ratnagiri, Devgad, Dapoli, Malvan, and Sindhudurg. The itinerary can be customized.',
    },
    {
        question: 'What types of cabs are available for the Konkan tour?',
        answer: 'We offer a wide range of vehicles including comfortable sedans, spacious SUVs, and tempo travellers to suit families, friend groups, and couples.',
    },
    {
        question: 'Can I customize the Konkan Darshan itinerary as per my interest?',
        answer: 'Absolutely! You can choose your preferred destinations, number of days, and stopovers. Our team will help you plan a flexible and enjoyable journey.',
    },
    {
        question: 'How long does the Pune to Konkan Darshan trip usually take?',
        answer: 'Konkan Darshan trips typically range from 3 to 5 days depending on the number of places you want to visit. One-way or round-trip options are also available.',
    },
    {
        question: 'What are the charges for a Pune to Konkan Darshan cab?',
        answer: 'Pricing varies based on the route, duration, and vehicle type. Contact Prince Cabs for a custom quote tailored to your travel needs.',
    },
    {
        question: 'Are the cabs suitable for hilly and coastal roads in Konkan?',
        answer: 'Yes, our cabs are well-maintained and driven by experienced drivers familiar with Konkan routes, ensuring a safe and smooth journey.',
    },
];

const testimonials = [
    {
        name: "Mr. Amol Sawant",
        position: "Nature Lover",
        text: "Prince Cabs made our Konkan Darshan unforgettable. The driver knew all the scenic spots, and the cab was perfect for our 4-day coastal tour.",
        image: "/img/testimonial/testimonial-thumb-konkan-1.png",
    },
    {
        name: "Mrs. Priya Bhosale",
        position: "Family Vacationer",
        text: "Our Pune to Konkan trip was super smooth with Prince Cabs. The vehicle was clean, spacious, and the service was excellent throughout.",
        image: "/img/testimonial/testimonial-thumb-konkan-2.png",
    },
];






























    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9284304420",
            "+91 8308844163",


        ],
        email: "booking@princecab.com"
    };


    const Images = [
  { place: "/images/keyword/1.jpg",  text: "Innova Cab on Rent in Hadapsar Pune",            link: "innova-cab-on-rent-in-hadapsar-pune" },
  { place: "/images/keyword/2.jpg",  text: "Pune To Mahabaleshwar Innova Cab",                link: "pune-to-mahabaleshwar-innova-cab" },
  { place: "/images/keyword/3.jpg",  text: "Pune to Shirdi Innova Cab Booking",               link: "pune-to-shirdi-innova-cab-booking" },
  { place: "/images/keyword/4.jpg",  text: "Pune to Mumbai Airport Innova Cab",               link: "pune-to-mumbai-airport-innova-cab" },
  { place: "/images/keyword/5.jpg",  text: "Pune to Goa Innova Cab",                          link: "pune-to-goa-innova-cab" },
  { place: "/images/keyword/6.jpg",  text: "Pune to Ashtavinayak Innova Tour Package",        link: "pune-to-ashtavinayak-innova-tour-package" },
  { place: "/images/keyword/7.jpg",  text: "Sedan Cab Service in Pune",                       link: "sedan-cab-service-in-pune" },
  { place: "/images/keyword/8.jpg",  text: "Etios Cab for Outstation in Pune",                link: "etios-cab-for-outstation-in-pune" },
  { place: "/images/keyword/9.jpg",  text: "Toyota Etios Cab Booking in Pune",                link: "toyota-etios-cab-booking-in-pune" },
  { place: "/images/keyword/10.jpg", text: "Swift Dzire On Rent Pune",                        link: "swift-dzire-on-rent-pune" },
  { place: "/images/keyword/11.jpg", text: "Pune to Shirdi Swift Dzire Cab",                  link: "pune-to-shirdi-swift-dzire-cab" },
  { place: "/images/keyword/12.jpg", text: "Pune to Mahabaleshwar Swift Dzire Cabs",          link: "pune-to-mahabaleshwar-swift-dzire-cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Dzire Cab",                        link: "pune-to-mumbai-dzire-cab" },
  { place: "/images/keyword/14.jpg", text: "Pune to Gujarat Cab",                             link: "pune-to-gujarat-cab" },
  { place: "/images/keyword/15.jpg", text: "Pune to Rajasthan Cab",                           link: "pune-to-rajasthan-cab" },
  { place: "/images/keyword/16.jpg", text: "Pune to Indore Cab Booking",                      link: "pune-to-indore-cab-booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Vijayawada Cabs",                         link: "pune-to-vijayawada-cabs" },
  { place: "/images/keyword/18.jpg", text: "Pune to Bangalore Cab",                           link: "pune-to-bangalore-cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Hyderabad Cab",                           link: "pune-to-hyderabad-cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Belgaum Cab",                             link: "pune-to-belgaum-cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mahabaleshwar Cab",                       link: "pune-to-mahabaleshwar-cab" },
  { place: "/images/keyword/22.jpg", text: "Pune to Panchgani Cab",                           link: "pune-to-panchgani-cab" },
  { place: "/images/keyword/23.jpg", text: "Pune to Goa Cab",                                 link: "pune-to-goa-cab" },
  { place: "/images/keyword/24.jpg", text: "Pune to Bhimashankar Cab",                        link: "pune-to-bhimashankar-cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Shirdi Cab",                              link: "pune-to-shirdi-cab" },
];




    const images = [
        { src: "/images/gallery/1.jpg", alt: "Image 1" },
        { src: "/images/gallery/5.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/4.jpg", alt: "Image 1" },
        { src: "/images/gallery/6.jpg", alt: "Image 1" },

    ];




const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Konkan Darshan Cab",
  "image": "https://princecab.com/assets/images/pune-konkan-darshan-cab.jpg",
  "description": "Book Pune to Konkan Darshan cab with Prince Cabs. Reliable taxi service for destinations like Diveagar, Palghar, Raigad, Ratnagiri, Sindhudurg, Thane, Kalyan, Dapoli, Shrivardhan, and Guhagar. Perfect for family tours and Konkan sightseeing. 24/7 online booking available.",
  "brand": {
    "@type": "Brand",
    "name": "Prince Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "7100"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "6000",
    "availability": "https://schema.org/InStock",
    "url": "https://princecab.com/pune-to-konkan-darshan-cab"
  }
};



    return (
        <div>
<Helmet>
  <title>Pune to Konkan Darshan Cab | Family & Tour Taxi Service | Prince Cabs</title>
  <meta
    name="description"
    content="Prince Cabs offers Pune to Konkan Darshan taxi service for destinations like Diveagar, Palghar, Raigad, Ratnagiri, Sindhudurg, and more. Affordable fares with comfortable cabs perfect for family tours. Book online 24/7."
  />
  <meta
    name="keywords"
    content="Pune to Diveagar Cab, Pune to Palghar Cab Booking, Pune to Raigad Taxi Price, Pune to Ratnagiri Innova Crysta Taxi Fare, Pune to Sindhudurg by Cab, Pune to Thane Cab, Pune to Kalyan Cab, Pune to Dapoli Taxi Service, Pune to Shrivardhan Cab, Pune to Guhagar Innova Cab, Pune to Konkan Tour Cab, Pune to Konkan Family Taxi"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section className="inner-banner-wrap">
                <div
                    className="inner-baner-container"
                    style={{ backgroundImage: 'url(/images/inner-banner.jpg)' }}
                >
                    <div className="container">
                        <div className="inner-banner-content">
                            <h1 className="inner-title">{cardData.keyword} </h1>
                        </div>
                    </div>
                </div>
                <div className="inner-shape"></div>
            </section>







            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/15.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#AF3125', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                             <div className="topPlaces">
  <p className="sectionLead">{cardData.top}</p>

  {cardData.topPlaces.map((place, index) => (
    <article key={index} className="placeCard" tabIndex="0">
      <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

      <div className="placeBody">
        <h4 className="placeTitle">{place.title}</h4>
        <p className="placeDesc">{place.description}</p>
      </div>

      <span className="placeArrow" aria-hidden>›</span>
    </article>
  ))}
</div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vihaan Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


 <ContactShowcase/>
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
  {Images.map((e, i) => {
    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

    return (
      <a
        key={e.link || i}
        href={href}
        className="routeItem"
        aria-label={e.text}
        {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
      >
        <div className="routeThumb">
          <img src={e.place} alt="" loading="lazy" />
        </div>

        <div className="routeMeta">
          <h6 className="routeTitle">{e.text}</h6>
          <span className="routeUnderline" />
        </div>

        <span className="routeArrow" aria-hidden>›</span>
      </a>
    );
  })}
</div>



                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                        </div> */}
<div>
  <FleetHighway/>
</div>
                            <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919284304420" className="pc-call">+91 9284304420</a>
        <a href="tel:+918308844163" className="pc-call">+91 8308844163</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919284304420"
          target="_blank" rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp me-1"></i> WhatsApp
        </a>
        <a href="tel:+919284304420" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@princecab.com" className="pc-email">
        booking@princecab.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-house-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Prince Cabs</strong><br />
        Office No 106, 2nd Floor, Nilgiri Nest Co-op Housing Society,<br />
        Pimple Gurav, Pune, Pin - 411027
      </address>
    </section>
  </div>
</div>



                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetokonkandarshan;